import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 批量打印选中选")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_14 = {
  class: "msi-content",
  style: {"margin-top":"0"}
}
const _hoisted_15 = { class: "dialog-footer" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_18 = { class: "slot_title" }
const _hoisted_19 = { class: "title_orderNo" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, "盘点范围", -1)

import {ref,nextTick,computed,watch} from 'vue'
    import {getCheckPlanPage,getCheckPlanRange,passCheckPlan,rejectCheckPlan,getCheckPlanDetail} from '@/service/main/check/checkOrder'
    import { getMaterialInfoList } from '@/service/main/warehouse';
    import { getCheckRulesPage} from '@/service/main/check/checkRules';
    import { getAreaInfoList} from '@/service/main/warehouse';
    import { ElMessage, ElMessageBox } from 'element-plus';
    import { exportExcel } from "@/utils/exportExcel";
    import Pagination from '@/components/Pagination/index.vue'
    import print from 'print-js'
    import {useStore} from '@/store'
    import {amountFormat} from '@/utils/formate'
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const store = useStore();

    //盘点规则枚举
    const checkRulesEnum = ref<{value: string,title: string}[]>([]);

    //盘点维度枚举
    const checkTypeEnum = ref<{value: number,title: string}[]>([{value: 0,title:'盘点仓库'},{value: 1,title: '盘点物料'}]);

    //仓库枚举
    const wareStoreHouseEnum = computed(() => store.state.login.enums.wareStoreHouse);

    //当亲仓库下的库区枚举
    const wareRegionEnum = ref<{value: string,title: string}[]>([]);
    
    //盘点计划状态
    const checkStatusEnum = computed(() => store.state.login.enums.enumCheckStatus); 

    //查询
    const formModel = ref({
      OrderNo: '',
      Status: '',
      PageNo: 1,
      PageSize: 10
    });

    //盘点计划列表
    let tableData = ref([]);

    //列表的数据条数
    const totalItems = ref<number>(0);

    //获取菜单列表
    const getTabelData = () => {
      getCheckPlanPage(formModel.value).then(res => {
        if(res.code == 200) {
          const {data} = res;
          const result = data;
          tableData.value = result.rows;
          totalItems.value = result.totalRows;
        }else {
          ElMessage.error(`${res.code}:${res.message}`)
        } 
      }).catch(err => {
        console.log(err)
        ElMessage.error(err)
      })
    }

    getTabelData();

    //重置搜索
    const resetForm = () => {
      formModel.value = {
        OrderNo: '',
        Status: '',
        PageNo: 1,
        PageSize: 10
      }
      getTabelData();
    }

    //选中的行
    const checkRows = ref<{id:number}[]>([]);

    // 选择
    const handleSelectionChange = (val: any) => {
      checkRows.value = val;
    }
    //导出
    const handExport = () => {
      let entozh = {
          id: "序号",
          orderNo: "盘点计划号",
          ruleNo: "规则序列号",
          ruleName: "规则名称",
          statusName: '计划状态',
          checkTypeName: '盘点类型',
          planDate: '计划盘点日期',
          createdUserName: '创建人'
        };
      exportExcel(checkRows.value, entozh, "xlsx", "盘点计划信息表");
    }
    
    //打印
    const printTable = () => {
      print({
        printable: checkRows.value,
        type: 'json',
        properties: [
          { field: 'orderNo', displayName: '盘点计划号'},
          { field: 'ruleNo', displayName: '规则序列号'},
          { field: 'ruleName', displayName: '规则名称'},
          { field: 'statusName', displayName: '计划状态'},
          { field: 'checkTypeName', displayName: '盘点类型'},
          { field: 'planDate', displayName: '计划盘点日期'},
          { field: 'createdUserName', displayName: '创建人'}
        ],
        header: '<h3 style="text-align: center;">盘点计划列表</h3>',
        sytle: '.custom-h3 { color: red; }'
      })
    }

    //-------------------------盘点计划范围-------------------------
    //入库单下物料详情请求
    const detailForm = ref({
        PlanId: '',
        CheckType: '',
        PageNo: 1,
        PageSize: 10
    })

    // 物料详情抽屉
    const drawerVisible = ref(false);

    //单据号
    const orderNo = ref('');

    //打开抽屉
    const openDrawer = (scope: any = {}) => {
      //当前入库单号id
      detailForm.value.PlanId = scope.id;
      detailForm.value.CheckType = scope.checkType;
      //计划号
      orderNo.value = scope.orderNo;
      //获取物料列表
      getDetail();
      drawerVisible.value = true;
    }

    //关闭抽屉
    const handleDrawerClose = () => {
      detailForm.value = {
        PlanId: '',
        CheckType: '',
        PageNo: 1,
        PageSize: 10
      }

      deltailList.value = [];
      detailCount.value = 0;

    }

    //盘点计划范围列表
    const deltailList = ref<any[]>([]);

    //盘点计划范围数据条数
    const detailCount = ref(0);

    //盘点计划范围
    const getDetail = () => {
        getCheckPlanRange(detailForm.value).then(res =>{
            if(res.code == 200) {
                const {data} = res;
                const result = data;
                deltailList.value = result.rows;
                detailCount.value = result.totalRows;
            }else {
                ElMessage.error(JSON.stringify(`获取计划范围失败${res.code}:${JSON.stringify(res.message)}`));
            }
        }).catch(err => ElMessage.error(JSON.stringify(err)))
    }

    // -------------------驳回、通过--------------------------------
    const rejectForm = ref({
      orderNo: '',
      rejectMsg: ''
    })

    const formRules = {
      rejectMsg: [{required: true,message: '驳回理由不能为空',trigger: 'blur'}],
    }
    
    //驳回窗口
    const dialogVisible = ref(false);


    //驳回表单ref
    const dialogRef = ref();

    //打开驳回窗口
    const reject = (scope: any) => {
      rejectForm.value.orderNo = scope.orderNo;
      dialogVisible.value = true;
      //清除上一次校验
      nextTick(() => {
        dialogRef.value.clearValidate();
      })
    }

    //关闭驳回窗口回调
    const closeDialog = () => {
      rejectForm.value = {
        orderNo: '',
        rejectMsg: ''
      }
    }
    
    //确认驳回
    const confirmReject = () => {
      dialogRef.value.validate((vali: any) => {
        if(vali) {
          rejectCheckPlan(rejectForm.value).then(res => {
            if(res.code == 200) {
              ElMessage.success('驳回成功');
              getTabelData();
              dialogVisible.value = false;
            }else {
              ElMessage.error( `驳回失败${res.code}:${JSON.stringify(res.message)}`);
            }
          }).catch(err => ElMessage.error(JSON.stringify(err)))
        }else {
          ElMessage.warning('驳回理由不能为空')
        }
      })
    }

    //通過
    const pass = (orderNo: string) => {
      ElMessageBox.confirm('是否确认通过该盘点计划？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        passCheckPlan({OrderNo: orderNo}).then().then(res => {
            if(res.code == 200) {
              ElMessage.success('计划通过成功');
              getTabelData();
              dialogVisible.value = false;
            }else {
              ElMessage.error( `计划通过失败${res.code}:${JSON.stringify(res.message)}`);
            }
          }).catch(err => ElMessage.error(JSON.stringify(err)))
      }).catch(() => ElMessage.info('已取消通过'))
      
    }
    // ------------------详情---------------------------------------
    //窗口类型
    const dialogType = ref('add')

    //物料列表
    const warehousOrderDetails = ref<any[]>([]);

    const detailVisible = ref(false);

    //操作表单ref
    const detailRef = ref();
    
    //获取盘点计划明细
    const getPlanDetail = (id: number,checkType: number) => {
        getCheckPlanDetail({PlanId: id,CheckType: checkType}).then(res => {
            if(res.code == 200) {
                const {data} = res;
                const result = data;
                if(checkType == 0) {
                    addForm.value.storehouse.wareStorehouseCode = result.storehouse.wareStorehouseCode;
                    setTimeout(() => {
                        addForm.value.storehouse.wareRegionCode = Array.isArray(result.storehouse.wareRegionCode) ? result.storehouse.wareRegionCode: [];
                    },300)
                    
                }else {
                    result.materials.forEach(item => {
                        warehousOrderDetails.value.push(JSON.parse(item.jsonData))
                    })
                }
            }else {
                ElMessage.error(`获取盘点计划明细失败${res.code}:${JSON.stringify(res.message)}`)
            }
        }).catch(err => ElMessage.error(JSON.stringify(err)))
    }
    //打开窗口
    const openDetailDialog  = (scope: any = {}) => {
      const {checkType,orderNo,ruleNo,planDate,remarks} = Object.assign({},scope);
      // addForm.value = {checkType,orderNo,ruleNo,planDate,remarks}
      addForm.value.checkType = checkType;
      addForm.value.orderNo = orderNo;
      addForm.value.ruleNo = ruleNo;
      addForm.value.planDate = planDate;
      addForm.value.remarks = remarks;
      getPlanDetail(scope.id,scope.checkType);
      detailVisible.value = true;
    }

    //添加/编辑
    let addForm = ref({
      orderNo: '',
      ruleNo: '',
      planDate: '',
      remarks: '',
      checkType: 0,
      materials: [] as {wareMaterialCode: string,batchNo: string}[],
      storehouse: {
          wareStorehouseCode: '',
          wareRegionCode: [] as string[]
      }

    })

    //日期选择不能大于当前时间
    const disabledDate = (time: Date) => {
      return  time.getTime() <= Date.now();
    }

    //关闭窗口
    const closeDetailDialog = () => {
        addForm.value = {
            orderNo: '',
            ruleNo: '',
            planDate: '',
            remarks: '',
            checkType: 0,
            materials: [] as {wareMaterialCode: string,batchNo: string}[],
            storehouse: {
                wareStorehouseCode: '',
                wareRegionCode: [] as string[]
            }
        }

        warehousOrderDetails.value = [];
        detailRef.value.clearSelection();

    }
    

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "盘点计划号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.OrderNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.OrderNo) = $event)),
                        clearable: "",
                        placeholder: "请输入盘点计划号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "计划状态:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formModel.value.Status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.Status) = $event)),
                        clearable: "",
                        placeholder: "请选择盘点计划状态",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkStatusEnum), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              value: item.value,
                              label: item.title
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "iconfont icon-biaoqianguanli",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: printTable
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange,
        size: "mini"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_form, {
                "label-position": "left",
                "label-width": "180px",
                inline: "",
                class: "demo-table-expand"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "备注" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.remarks), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.createdTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.createdUserName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "修改日期" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.updatedTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "修改人" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.updatedUserName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "驳回理由" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.rejectMsg), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            width: "60",
            type: "selection"
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点计划号",
            prop: "orderNo",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                onClick: ($event: any) => (openDetailDialog(scope.row)),
                class: "under_line"
              }, _toDisplayString(scope.row.orderNo), 9, _hoisted_8)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "规则序列号",
            prop: "ruleNo",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "规则名称",
            prop: "ruleName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "计划状态",
            prop: "statusName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "计划盘点日期",
            prop: "planDate",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "创建日期",
            prop: "createdTime",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "220px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-edit",
                disabled: scope.row.status != 0,
                onClick: ($event: any) => (reject(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-delete",
                disabled: scope.row.status == 1,
                onClick: ($event: any) => (pass(scope.row.orderNo))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      title: "盘点计划驳回",
      width: "30%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmReject
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: rejectForm.value,
          "label-width": "100px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "驳回理由:",
                      prop: "rejectMsg"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: rejectForm.value.rejectMsg,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rejectForm.value.rejectMsg) = $event)),
                          type: "textarea",
                          rows: 4,
                          clearable: "",
                          placeholder: "请输入驳回理由"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((detailVisible).value = $event)),
      title: "盘点详情",
      width: "60%",
      onClose: closeDetailDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (detailVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "120px",
          ref_key: "detailRef",
          ref: detailRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点计划号:",
                      prop: "orderNo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).orderNo,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).orderNo) = $event)),
                          clearable: "",
                          disabled: "",
                          placeholder: "请输入盘点计划号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点规则:",
                      prop: "ruleNo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).ruleNo,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).ruleNo) = $event)),
                          clearable: "",
                          disabled: "",
                          placeholder: "请选择盘点规格",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkRulesEnum.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点日期:",
                      prop: "planDate"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _unref(addForm).planDate,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addForm).planDate) = $event)),
                          type: "date",
                          disabled: "",
                          format: "YYYY-MM-DD",
                          "value-format": "YYYY-MM-DD",
                          clearable: "",
                          placeholder: "请选择日期",
                          "disabled-date": disabledDate,
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "备注" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).remarks,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(addForm).remarks) = $event)),
                          clearable: "",
                          disabled: "",
                          placeholder: "请输入计划备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点维度:",
                      prop: "checkType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).checkType,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(addForm).checkType) = $event)),
                          clearable: "",
                          disabled: "",
                          placeholder: "请选择盘点维度",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkTypeEnum.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "选择仓库:" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).storehouse.wareStorehouseCode,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(addForm).storehouse.wareStorehouseCode) = $event)),
                          clearable: "",
                          disabled: "",
                          placeholder: "请选择需要盘点的仓库",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wareStoreHouseEnum), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _unref(addForm).checkType == 0]
                ]),
                _withDirectives(_createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "选择库区:" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).storehouse.wareRegionCode,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(addForm).storehouse.wareRegionCode) = $event)),
                          clearable: "",
                          disabled: "",
                          placeholder: "请选择需要盘点的库区",
                          multiple: "",
                          "collapse-tags": "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wareRegionEnum.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _unref(addForm).checkType == 0]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _withDirectives(_createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_table, {
            data: warehousOrderDetails.value,
            border: "",
            style: {"width":"100%"},
            "row-key": "id",
            ref_key: "detailRef",
            ref: detailRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60",
                type: "index"
              }),
              _createVNode(_component_el_table_column, {
                label: "物料编号",
                prop: "wareMaterialCode",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "物料名称",
                prop: "wareMaterialName",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "库存数量",
                prop: "occQuantity",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "价格",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price + '',2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "总价",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price * scope.row.occQuantity + '',2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "单位",
                prop: "unit",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "条码",
                prop: "barCode",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "批次",
                prop: "batchNo",
                align: "center",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"])
        ], 512), [
          [_vShow, _unref(addForm).checkType == 1]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: drawerVisible.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((drawerVisible).value = $event)),
      title: "计划范围",
      direction: "rtl",
      size: "80%",
      onClose: handleDrawerClose
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(orderNo.value), 1),
          _hoisted_20
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: deltailList.value,
          border: "",
          striped: "",
          style: {"width":"96%","margin":"10px auto"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              align: "center",
              width: "60",
              type: "index"
            }),
            _createVNode(_component_el_table_column, {
              label: "物料编号",
              prop: "wareMaterialCode",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "物料名称",
              prop: "wareMaterialName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "数量",
              prop: "quantity",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "单价",
              prop: "price",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price + '',2,false)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "总价",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price * scope.row.quantity + '',2,false)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "批次",
              prop: "batchNo",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "仓库",
              prop: "wareStorehouseName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "库区",
              prop: "wareRegionName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "库位名称",
              prop: "wareLocationName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "容器编号",
              prop: "wareContainerCode",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(Pagination, {
          total: detailCount.value,
          page: detailForm.value.PageNo,
          "onUpdate:page": _cache[17] || (_cache[17] = ($event: any) => ((detailForm.value.PageNo) = $event)),
          limit: detailForm.value.PageSize,
          "onUpdate:limit": _cache[18] || (_cache[18] = ($event: any) => ((detailForm.value.PageSize) = $event)),
          onPagination: getDetail,
          style: {"margin-top":"20px","text-align":"center"}
        }, null, 8, ["total", "page", "limit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})